import React, { ReactElement, useMemo } from 'react'
import { Center, HStack, useColorModeValue, Image } from '@chakra-ui/react'
import { Notifications, ProfileButton } from 'components'
import { useAuthContext } from 'context/AuthProvider'
import { Property } from 'generated/graphql'
import { useTranslation } from 'react-i18next'
import { VscHeart, VscHome, VscSearch } from 'react-icons/vsc'
import { NavLink, useHistory } from 'react-router-dom'
import { get } from 'js-cookie'
import { images, theme } from 'theme'

const LinkItem: React.FC<{ label: string; icon: ReactElement; to: string }> = ({
  // label,
  icon,
  to
}) => {
  const color = useColorModeValue(theme.colors.blue[400], theme.colors.blue[200])
  return (
    <Center flex={1}>
      <NavLink
        to={to}
        exact
        activeStyle={{
          fontWeight: 'bold',
          color
        }}
      >
        <Center flexDirection="column">
          {icon}
          {/* <Text fontSize="xs">{label}</Text> */}
        </Center>
      </NavLink>
    </Center>
  )
}

type BottomNavProps = {}
const BottomNav: React.FC<BottomNavProps> = ({}) => {
  const bg = useColorModeValue('white', 'gray.700')
  const { user, logout, isAuthenticated, isAgent } = useAuthContext()
  const { t } = useTranslation()
  const history = useHistory()
  const cookie = get('lng')
  const handleLogout = () => {
    logout && logout()
    history.push('/')
  }
  const items = useMemo(
    () => [
      {
        icon: <VscHome size={19} />,
        label: t('home_title'),
        to: isAuthenticated ? '/auth' : '/'
      },
      {
        icon: <VscSearch size={19} />,
        label: t('search_btn'),
        to: isAuthenticated ? '/auth/search' : '/search'
      },
      ...(isAuthenticated && isAgent
        ? [
            {
              icon: (
                <Image
                  src={images.icon}
                  top="0"
                  transform="translateY(-50%)"
                  rounded="full"
                  position="absolute"
                  width={16}
                />
              ),
              label: t('search_btn'),
              to: isAuthenticated ? '/auth/dashboard/agent/dashboard' : '/'
            }
          ]
        : [])
    ],
    [cookie, isAuthenticated]
  )

  return (
    <HStack
      position="fixed"
      bg={bg}
      zIndex={48}
      boxShadow={theme.boxShadow2}
      rounded="xl"
      py={4}
      mb={4}
      bottom={0}
      left="50%"
      transform="translateX(-50%)"
      width="90%"
    >
      {items.map((item, idx) => (
        <LinkItem {...item} key={idx} />
      ))}

      <Center flex={1}>
        <Notifications
          aria-label="Favorites"
          // label={t('Saved')}
          size="xs"
          variant="unstyled"
          icon={<VscHeart size={19} color={theme.colors.red[300]} />}
          properties={user?.favorites_properties as Property[]}
          title={t('Saved')}
        />
      </Center>

      <Center flex={1}>
        <ProfileButton user={user} onLogout={handleLogout} />
      </Center>
    </HStack>
  )
}

export default BottomNav
